<template>
    <div>
        <div>
            <b-button class="me-2" variant="light" @click="$eventHub.$emit('navigateBack')">
                <i class="fas fa-arrow-left"></i> Back
            </b-button>
        </div>
        <hr>
        <webix-ui :config="config" v-model="module_data"></webix-ui>
    </div>
</template>

<script>
import { ccbAdminState } from '@/state/helpers'
export default {
    data:() => ({
        config:{
            id: 'applicantModulesTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'id', header:'', hidden: true},
                { id: 'name', header:'Name', fillspace: true},
                { id: 'q', header:'Signup Date', fillspace: 0.5},
                { id: 'q', header:'Expiry Date', fillspace: 0.5},
                { id: 'renewal', header:'Renewal', fillspace: 0.5},
                { id: 'status', header:'Status', fillspace: 0.5},
            ]
        }
    }),
    computed:{
        ...ccbAdminState,
        module_data(){
            return this.client_data.modules;
        }
    },
    methods:{},
    mounted(){
        this.$nextTick(()=>{
            //eslint-disable-next-line
            let table = $$('applicantModulesTable');
            if(table != undefined){
                table.refresh();
            }
        })
    },
}
</script>

<style>

</style>